<div class="password-requirements" [class.password-requirements--met]="allMet">
  <div class="password-requirements__title">Password must:</div>
  <ul class="password-requirements__list">
    <li
      *ngFor="let req of requirements"
      class="password-requirements__item"
      [class.password-requirements__item--met]="req.met"
    >
      <i class="material-icons" aria-hidden="true">{{ req.met ? 'check_circle' : 'radio_button_unchecked' }}</i>
      <span>{{ req.label }}</span>
    </li>
  </ul>
</div>
